<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Cotización</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div v-if="isDataLoaded" class="col-lg-6 col-5 text-right">
          <router-link
            v-if="canEditQuotation"
            :to="{ name: 'QuotationEdit', params: { id: quotationId } }"
            class="btn base-button btn-neutral btn-sm"
          >
            Editar
          </router-link>
          <button v-if="!isQuotationOpen" title="Descargar" class="btn base-button btn-neutral btn-sm" @click="getPdf">
            <i class="fas fa-download"></i>&nbsp;PDF
          </button>
        </div>
      </div>
    </base-header>
    <div v-if="isDataLoaded" class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-sm-12">
          <quotation-detail :quotation="quotation" :quotation-id="quotationId" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import QuotationDetail from './Show/QuotationDetail';
import QuotationStatesMixin from '@/mixins/quotationStatesMixin';

export default {
  name: 'QuotationsShow',
  components: {
    RouteBreadCrumb,
    QuotationDetail,
  },

  mixins: [QuotationStatesMixin],
  data() {
    return {
      isDataLoaded: false,
      quotationId: 0,
      quotation: null,
    };
  },

  computed: {
    canEditQuotation() {
      return (
        this.$can('store', 'quotations') &&
        !this.isQuotationSended &&
        this.$auth.user().data.id === this.quotation.user.id
      );
    },
  },

  mounted() {
    this.quotationId = +this.$route.params.id;
    this.fetchQuotation();
  },

  methods: {
    fetchQuotation() {
      const params = {
        include: [
          'producer.distributor.seller',
          'campaign',
          'state',
          'items.article',
          'user',
          'projection',
          'pictures',
        ],
      };

      this.$services
        .resource('quotations')
        .show(this.quotationId, params)
        .then((res) => res.data.data)
        .then((quotation) => {
          this.quotation = quotation;
          this.isDataLoaded = true;
        });
    },

    getPdf() {
      let filename = `${this.quotation.producer.businessName}-Cotización-${this.quotation.code}.pdf`;
      this.$services.resource('quotations').getPdf(this.quotation.id, filename);
    },
  },
};
</script>
